<template>
  <div class="child">
    <div>
      <div class="main">
        <div class="list">
          <div>项目介绍</div>
          <ul>
            <li v-for="item in tabs" :key="item.index">
              <router-link active-class="active" :to="{name:item.path}">{{item.type}}</router-link>
            </li>
            <!-- <li v-for="(tab,index) in tabs" v-bind:key="index" :class="{active:active==index}" @click="toggle(index,tab.view)">
              {{tab.type}}
            </li> -->
          </ul>
        </div>
        <div class="con">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProjectIntroduction',
  data () {
    return {
      tabs: [
        {
          type: '项目总体介绍',
          path: 'framework'
        }, {
          type: '项目团队',
          path: 'team'
        }, {
          type: '项目大事件',
          path: 'bigEvent'
        }
      ]
    }
  }
}
</script>
<style scoped src="../assets/style/child.css">
  /* @import '../assets/style/child.css'; */
</style>



// WEBPACK FOOTER //
// src/components/ProjectIntroduction.vue